import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';
import App from './App';
import create from 'zustand';
import * as serviceWorker from './serviceWorker';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { navigate } from '@reach/router';


const [useStore] = create((set:any) => ({
    status: 'idle',
    navigate: (address: any, domEl: any, state?: any) => {
      set({ status: 'transitioning' })
      if (domEl) disableBodyScroll(domEl)
      navigate(address, state)
    },
    endNav: () => {
      set({ status: 'idle' })
      clearAllBodyScrollLocks()
    }
  }))

 
  export { useStore }

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
